import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Content = styled.div`
    width: fit-content;
`;

export const Root = styled.div`
    overflow-x: auto;
    padding-left: ${theme.container.spacing.large};
    padding-right: ${theme.container.spacing.large};
`;
